import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import icon from '../../icon.png';

function ColorSchemesExample() {
    return (
        <>
            <Navbar variant="dark" sticky="top">
                <Container >
                    <Navbar.Brand href="/">
                        <img
                            alt=""
                            src={icon}
                            width="30"
                            height="30"
                            className="d-inline-block align-top"
                        />{' '}
                        Gateway Lambda
                    </Navbar.Brand>
                    <Nav className="me-auto">
                        <NavDropdown menuVariant="dark" title="Facilities" id="collasible-nav-dropdown">
                            <NavDropdown.Item href="/">Lambda</NavDropdown.Item>
                            <NavDropdown.Divider bg="white"/>
                            <NavDropdown.Item href="/alpha">Alpha</NavDropdown.Item>
                            <NavDropdown.Item href="/epsilon">Epsilon</NavDropdown.Item>
                        </NavDropdown>
                        <NavDropdown menuVariant="dark" title="Intranet" id="collasible-nav-dropdown">
                            <NavDropdown.Item href="http://gatewaylambda.space:14889/">VPN Monitor</NavDropdown.Item>
                            <NavDropdown.Item href="http://gatewaylambda.space:11111/">Registry UI</NavDropdown.Item>
                            <NavDropdown.Item href="http://gatewaylambda.space:5000/">Jupyter</NavDropdown.Item>
                        </NavDropdown>
                        <Nav.Link href="/parabola">Parabola</Nav.Link>
                        <Nav.Link href="https://kanban.gatewaylambda.space/">Kanban</Nav.Link>
                        <Nav.Link href="https://t.me/mugenmoon">Telegram (contact)</Nav.Link>
                        <Nav.Link href="https://axis.gatewaylambda.space/">Git</Nav.Link>
                        <Nav.Link href="https://git.wbydc.io/">wbydc.io Git</Nav.Link>
                        <Nav.Link href="https://dashboard.beta.gatewaylambda.space/">Minecraft</Nav.Link>
                    </Nav>
                </Container>
            </Navbar>
        </>
    );
}

export default ColorSchemesExample;